import {getFulfillment} from '@/services/Order/orderItemOverview'
import {useQueries} from '@tanstack/react-query'

export const useFulfillment = () => {
  const results = useQueries({
    queries: [{queryKey: ['ORDER_ITEM_OVERVIEW_FULFILLMENT'], queryFn: getFulfillment}],
  })

  const {fulfillmentJsonSchema, fulfillmentUISchema} = results?.[0]?.data || {}

  return {
    fulfillmentJsonSchema,
    fulfillmentUISchema,
  }
}
